import { useEffect, useState } from 'react';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Switch } from '../../ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../ui/dialog';

/**
 * Stand-alone dialog for setting/clearing a recurring email schedule on a
 * saved view. Parent passes `view` (or null) and an `onSubmit({enabled, frequency})`
 * callback.
 */
const ScheduleViewDialog = ({ view, onClose, onSubmit }) => {
  const [enabled, setEnabled] = useState(false);
  const [frequency, setFrequency] = useState('weekly');

  useEffect(() => {
    if (!view) return;
    setEnabled(Boolean(view.schedule?.enabled));
    setFrequency(view.schedule?.frequency || 'weekly');
  }, [view]);

  return (
    <Dialog open={Boolean(view)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="schedule-view-dialog">
        <DialogHeader>
          <DialogTitle>Email this view on a schedule</DialogTitle>
          <DialogDescription>
            We'll email you the current matches at the chosen frequency.
            Daily emails go out at 07:30; weekly emails on Mondays at 07:45.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="sched-enabled" className="text-sm">Enabled</Label>
            <Switch
              id="sched-enabled"
              checked={enabled}
              onCheckedChange={setEnabled}
              data-testid="schedule-enabled-switch"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="sched-freq">Frequency</Label>
            <Select value={frequency} onValueChange={setFrequency}>
              <SelectTrigger id="sched-freq" data-testid="schedule-frequency-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="daily">Daily</SelectItem>
                <SelectItem value="weekly">Weekly</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            onClick={() => onSubmit({ enabled, frequency })}
            className="bg-[#111565] hover:bg-[#111565]/90"
            data-testid="schedule-submit-btn"
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleViewDialog;
